export default __webpack_public_path__ + "static/media/img_marketplace_mobility.0a1be8aa.png";